import {
  ContactFormFields,
  useContactFormEffect,
  useUserFormEffect,
} from '../../../forms';
import {
  StoreState,
  useCreateContactEffect,
  useCreateUserFormAnswerEffect,
} from '../../../services';
import { useSelector } from 'react-redux';
import { Contact } from '@hiwaldo/sdk/interfaces';
import { PartnerFormQuestion } from '../../../enums';

export const usePartnerFormEffect = () => {
  const { contact, userFormQuestion } = useSelector((state: StoreState) => {
    return {
      contact: state.misc.contact.data,
      userFormQuestion: state.misc.userFormQuestion.data,
    };
  });

  const contactForm = useContactFormEffect();
  const userForm = useUserFormEffect([userFormQuestion]);

  const createUserFormAnswerState = useCreateUserFormAnswerEffect();

  const callback = (createdContact: Contact) => {
    const userFormAnswerValue = userForm.getFieldValues();
    const choices: { questionChoiceId: number }[] = [];
    const options = userFormAnswerValue[
      PartnerFormQuestion.PARTNER_CONTACT_REASONS
    ] as number[];

    options.forEach((choice) => choices.push({ questionChoiceId: +choice }));

    const data = {
      questionId: +userFormQuestion.id,
      entityId: +createdContact.id!,
      choices,
    };

    createUserFormAnswerState.createUserFormAnswer(data);
  };

  const createContactState = useCreateContactEffect(callback);

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = contactForm.getFieldValues() as ContactFormFields;

    const contactInput = {
      name: form.name!,
      email: form.email!,
      practice: form.practice!,
    };

    createContactState.createContact(contactInput);
  };

  return {
    contact,
    isValid: contactForm.isValid && userForm.isValid,
    members: contactForm.members,
    questions: userForm.members,
    onSubmit,
    loading: createUserFormAnswerState.loading || createContactState.loading,
    success: createUserFormAnswerState.success && createContactState.success,
    error: createUserFormAnswerState.error
      ? createUserFormAnswerState.error
      : createContactState.error
      ? createContactState.error
      : undefined,
  };
};
